var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.429 4.571H2.286V35.43H7.43V14.857h5.143V20h5.143v5.143h5.143V20H28v-5.143h5.143V35.43h5.143V4.57h-5.143v5.143H28v5.143h-5.142V20h-5.143v-5.143h-5.143V9.714H7.429V4.571z",
    fill: "#F7F7F7"
  })));
}

var MemoSvgLogo = /*#__PURE__*/React.memo(SvgLogo);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQyODk5IDQuNTcxNDRIMi4yODYxM1Y5LjcxNDNWMTQuODU3MlYyMFYyNS4xNDI5VjMwLjI4NTdWMzUuNDI4Nkg3LjQyODk5VjMwLjI4NTdWMjUuMTQyOVYyMFYxNC44NTcySDEyLjU3MThWMjBIMTcuNzE0N1YyNS4xNDI5SDIyLjg1NzZWMjBIMjguMDAwNFYxNC44NTcySDMzLjE0MzNWMjBWMjUuMTQyOVYzMC4yODU3VjM1LjQyODZIMzguMjg2MVYzMC4yODU3VjI1LjE0MjlWMjBWMTQuODU3MlY5LjcxNDNWNC41NzE0NEgzMy4xNDMzVjkuNzE0M0gyOC4wMDA0VjE0Ljg1NzJIMjIuODU3NlYyMEgxNy43MTQ3VjE0Ljg1NzJIMTIuNTcxOFY5LjcxNDNINy40Mjg5OVY0LjU3MTQ0WiIgZmlsbD0iI0Y3RjdGNyIvPgo8L3N2Zz4K";
export { MemoSvgLogo as ReactComponent };